"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/testimonialSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode, useRef } from "react";

type TestimonialSectionSlidersItem = {
    key: Key | null | undefined;
    /** Detected variants: "Exceptional cardiology care with precise diagnosis, advanced treatment options, and compassionate support throughout the journey. The team ensures timely monitoring, clear communication, and personalized guidance for every patient. Modern facilities, expert cardiologists, and seamless follow-ups create a reassuring experience." | "Outstanding cardiology services marked by expert evaluation, accurate testing, and personalized treatment plans. The medical team is knowledgeable, attentive, and committed to patient well-being. State-of-the-art equipment and a calm, supportive environment make every visit comfortable." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/patients/patient20.jpg" | "/Templates/Doccure/img/patients/patient24.jpg" | "/Templates/Doccure/img/patients/patient26.jpg" */
    src: string;
    /** Detected variants: "Lauren Parker" | "Michael Adams" */
    p0P0Text: ReactNode;
    /** Detected variants: "Seattle, WA" | "Chicago, IL" */
    p1Text: ReactNode;
    /** Detected variants: "slider-item" */
    className?: string;
    /** Detected variants: "testimonial-item-seven" */
    div0ClassName?: string;
    /** Detected variants: "testimonial-info" */
    div0ClassName2?: string;
    /** Detected variants: "quote-icon" */
    div1ClassName?: string;
    /** Detected variants: "quote" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/quote-icon-03.svg" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "testimonial-content" */
    div1ClassName2?: string;
    /** Detected variants: "sub-title" */
    p0ClassName?: string;
    /** Detected variants: "testimonial-author-info" */
    div2ClassName?: string;
    /** Detected variants: "testimonial-author-img" */
    div0ClassName3?: string;
    /** Detected variants: "patient" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "rounded-circle" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "author-name" */
    p0ClassName2?: string;
    /** Detected variants: "author-location" */
    p1ClassName?: string;
    ratingItems?: TestimonialSectionFaSolidFaStarFilled1sItem[];
};

type TestimonialSectionFaSolidFaStarFilled1sItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star filled me-1" | "fa-solid fa-star filled" */
    className: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false, // arrows handled externally
    vertical: true,
    verticalSwiping: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                vertical: false,
                verticalSwiping: false,
            },
        },
    ],
};

export type HomeSevenTestimonialSectionGeneratedProps = {
    divDiv0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div2Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "Clients Testimonials" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "What people say" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "about us worldwide" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "K+" */
    sectionDiv0Div1Div0Div0Div0H30H3Text?: ReactNode;
    sectionDiv0Div1Div0Div0Div0H30H3Visible?: boolean;
    sectionDiv0Div1Div0Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: 4.9 */
    sectionDiv0Div1Div0Div0Div0H30Span0SpanText?: ReactNode;
    /** Default: "Client Reviews" */
    sectionDiv0Div1Div0Div0Div0P0PText?: ReactNode;
    /** Default: "reviews" */
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/reviews/testimonial.jpg" */
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1Div1Div0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/circle-bg.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/testimonial-bg-02.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    testimonialSectionSliders: TestimonialSectionSlidersItem[];
    testimonialSectionSlidersItemWrapper?: (item: TestimonialSectionSlidersItem, content: ReactNode) => ReactNode;
    testimonialSectionSlidersRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidersImageVisible?: boolean;
    testimonialSectionSlidersImageRenderer?: (item: TestimonialSectionSlidersItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidersImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionFaSolidFaStarFilled1sItemWrapper?: (item: TestimonialSectionFaSolidFaStarFilled1sItem, content: ReactNode) => ReactNode;
    testimonialSectionFaSolidFaStarFilled1sRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSevenTestimonialSectionGenerated: FC<HomeSevenTestimonialSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Clients Testimonials",
    sectionDiv0Div0H20H2Text = "What people say",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "about us worldwide",
    sectionDiv0Div1Div0Div0Div0H30H3Text = "K+",
    sectionDiv0Div1Div0Div0Div0H30H3Visible,
    sectionDiv0Div1Div0Div0Div0H30H3Renderer,
    sectionDiv0Div1Div0Div0Div0H30H3Props,
    sectionDiv0Div1Div0Div0Div0H30Span0SpanText = 4.9,
    sectionDiv0Div1Div0Div0Div0P0PText = "Client Reviews",
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt = "reviews",
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/reviews/testimonial.jpg",
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/circle-bg.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/testimonial-bg-02.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0Div1ImageWithBasePath0ImageProps,
    divDiv0Div2Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0Slider0SliderProps,
    sectionDiv0Div1ClassName,
    testimonialSectionSliders,
    testimonialSectionSlidersItemWrapper,
    testimonialSectionSlidersRenderer,
    testimonialSectionSlidersImageVisible,
    testimonialSectionSlidersImageRenderer,
    testimonialSectionSlidersImageProps,
    testimonialSectionFaSolidFaStarFilled1sItemWrapper,
    testimonialSectionFaSolidFaStarFilled1sRenderer,
}) => {
    const sliderRef = useRef<Slider | null>(null);
    return (
        <section className="testimonial-section-seven section">
            <div className="container">
                <div className="section-header section-header-seven text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row align-items-center"}>
                    <div className="col-lg-5">
                        <div className="testimonial-image">
                            {renderNode(sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            <div className="testimonial-reviews">
                                {renderNode(sectionDiv0Div1Div0Div0Div0H30H3Visible, sectionDiv0Div1Div0Div0Div0H30H3Renderer, (
                                    <h3 {...(sectionDiv0Div1Div0Div0Div0H30H3Props ?? {})}>
                                        <span>{sectionDiv0Div1Div0Div0Div0H30Span0SpanText}</span>
                                        {sectionDiv0Div1Div0Div0Div0H30H3Text}
                                    </h3>
                                ))}
                                <p>{sectionDiv0Div1Div0Div0Div0P0PText}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="slider-content">
                            <Slider ref={sliderRef} className="testimonial-slider-seven" {...settings} {...(sectionDiv0Div1Div1Div0Slider0SliderProps ?? {})}>
                                {renderCollectionNode(
                                    testimonialSectionSliders,
                                    (item: TestimonialSectionSlidersItem) => (
                                        <div className={item.className ?? "slider-item"} key={item.key}>
                                            <div className={item.div0ClassName ?? "testimonial-item-seven"}>
                                                <div className={item.div0ClassName2 ?? "testimonial-info"}>
                                                    <div className="rating">
                                                        {renderCollectionNode(
                                                            item.ratingItems ?? [],
                                                            (item: TestimonialSectionFaSolidFaStarFilled1sItem) => (
                                                                <i className={item.className} key={item.key} />
                                                            ),
                                                            testimonialSectionFaSolidFaStarFilled1sItemWrapper,
                                                            testimonialSectionFaSolidFaStarFilled1sRenderer
                                                        )}
                                                    </div>
                                                    <div className={item.div1ClassName ?? "quote-icon"}>
                                                        {renderItemNode(testimonialSectionSlidersImageVisible, testimonialSectionSlidersImageRenderer, item, (
                                                            <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/quote-icon-03.svg"} alt={item.alt ?? "quote"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof testimonialSectionSlidersImageProps === "function" ? testimonialSectionSlidersImageProps(item) : (testimonialSectionSlidersImageProps ?? {}))} {...(typeof divDiv0Div0Div1ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div1ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div1ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className={item.div1ClassName2 ?? "testimonial-content"}>
                                                    <p className={item.p0ClassName ?? "sub-title"}>{item.p0Text}</p>
                                                </div>
                                                <div className={item.div2ClassName ?? "testimonial-author-info"}>
                                                    <div className={item.div0ClassName3 ?? "testimonial-author-img"}>
                                                        {renderItemNode(testimonialSectionSlidersImageVisible, testimonialSectionSlidersImageRenderer, item, (
                                                            <SmartImage src={item.src} className={item.imageWithBasePath0ClassName2 ?? "rounded-circle"} alt={item.imageWithBasePath0Alt ?? "patient"} {...(typeof testimonialSectionSlidersImageProps === "function" ? testimonialSectionSlidersImageProps(item) : (testimonialSectionSlidersImageProps ?? {}))} {...(typeof divDiv0Div2Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div2Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div2Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </div>
                                                    <div>
                                                        <p className={item.p0ClassName2 ?? "author-name"}>{item.p0P0Text}</p>
                                                        <p className={item.p1ClassName ?? "author-location"}>{item.p1Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    testimonialSectionSlidersItemWrapper,
                                    testimonialSectionSlidersRenderer
                                )}
                            </Slider>
                            <div className="arrow-icon">
                                <div className="testimonial-prev">
                                    <i className="isax isax-arrow-up-2" />
                                </div>
                                <div className="testimonial-next">
                                    <i className="isax isax-arrow-down-1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="testimonial-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="testimonial-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSevenTestimonialSectionGenerated;
